module.exports = __webpack_public_path__ + "static/media/ios-list-box.a9797658.svg";